import { createSlice } from "@reduxjs/toolkit";
import http from "../../common/cticApi";

// initial state
export const initialState = {
  loading: false,
  error: null,
  success: false,
  notificationDetails: null,
  notificationHistory: null,
  notificationLawyer:null
};

// our slice
const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    setLoading: (state) => {
      state.loading = true;
    },
    setError: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
      state.success = false;
    },
    setSuccess: (state) => {
      state.loading = false;
      state.error = false;
      state.success = true;
    },
    setNotification: (state, { payload }) => {
      state.notificationDetails = payload;
    },
    setNotificationHistory: (state, { payload }) => {
      state.notificationHistory = payload;
    },
    setNotificationLawyer: (state, { payload }) => {
      state.notificationLawyer = payload;
    },
  },
});
// export the actions
export const {
  setLoading,
  setError,
  setSuccess,
  setNotification,
  setNotificationHistory,
  setNotificationLawyer
} = notificationSlice.actions;

export const notificationSelector = (state) => state.notification;

// export the default reducer
export default notificationSlice.reducer;

// notifications API's
export const GetNotificationsDetails =
  (userid, islawyer, firmid, hasfirmBilling) => async (dispatch) => {
    try {
      dispatch(setLoading());
      let request = {
        UserID: userid,
        FirmID: firmid,
        IsLawyer: islawyer,
        FirmBilling: hasfirmBilling,
      };

      let req = { UserID: userid, RequestObject: request };
      const results = await http
        .post("Lawfirm/GetNotificationsDetails", req)
        .then((result) => {
          return result;
        });

      if (results.data.responseCode == 0) {
        dispatch(setNotification(results.data.responseObject.lstnotifications));
        dispatch(
          setNotificationHistory(
            results.data.responseObject.notificationHistory
          )
        );
        dispatch(setSuccess());
      }
    } catch (error) {
      const errorMessage =
        error.response && error.response.data
          ? error.response.data.title
          : error.message;
      dispatch(setError(errorMessage));
    }
  };

export const SaveNotificationsDetails =
  (notifications, userid, islawyer, { toast }) =>
  async (dispatch) => {
    try {
      dispatch(setLoading());
      let finalRequest = {};
      finalRequest.NotificationsDetails = notifications[0];
      let req = { UserID: userid, RequestObject: finalRequest };
      const results = await http
        .post("Lawfirm/SaveNotificationsDetails", req)
        .then((result) => {
          return result;
        });

      if (results.data.responseCode == 0) {
        toast("Notification(s) saved successfully!", { type: "success" });
        dispatch(
          GetNotificationsDetails(
            userid,
            islawyer,
            notifications[0]?.FirmID,
            notifications[0]?.HasFirmBilling
          )
        );
        dispatch(setSuccess());
      }
    } catch (error) {
      const errorMessage =
        error.response && error.response.data
          ? error.response.data.title
          : error.message;
      dispatch(setError(errorMessage));
    }
  };

export const DeleteNotification =
  (ID, userid, isFirmBilling, { toast }) =>
  async (dispatch) => {
    try {
      dispatch(setLoading());
      let request = {
        ID: ID,
        IsLawFirm: isFirmBilling,
      };
      let req = { UserID: userid, RequestObject: request };
      const results = await http
        .post("Lawfirm/DeleteNotification", req)
        .then((result) => {
          return result;
        });

      if (results.data.responseCode == 0) {
        toast("Notification deleted successfully!", { type: "success" });
        dispatch(GetNotificationsDetails(userid, islawyer));
        dispatch(setSuccess());
      }
    } catch (error) {
      const errorMessage =
        error.response && error.response.data
          ? error.response.data.title
          : error.message;
      dispatch(setError(errorMessage));
    }
  };
